<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="500" content-class="rounded-lg" scrollable @keydown.esc="dialog = false">
			<v-card>
				<v-card-title class="text-body-1 text-md-h6">
					<span class="black--text text-uppercase font-weight-bold">Pilih Bank</span>
					<v-spacer></v-spacer>
					<v-btn text small color="pink" class="mr-n4" @click="modalHide">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text class="pb-0">
					<div class="py-2"><v-divider></v-divider></div>
					<v-row v-for="listBank in bankAccountList" :key="listBank.bank_account_id">
						<v-col cols="2" sm="1" md="1" class="pb-0 pb-md-3">
							<v-radio-group class="mt-0 mt-sm-2" v-model="selectedBank">
								<v-radio class="small-check mt-0" :value="listBank"></v-radio>
							</v-radio-group>
						</v-col>
						<v-col cols="4" sm="3" md="3" class="pb-0 pb-md-3">
							<v-img width="100%" :src="`/assets/bank/${listBank.bank_account_bank_name.toLowerCase()}.svg`"></v-img>
						</v-col>
						<!-- <v-col sm="3" md="3" class="pb-0 pb-md-3 pt-0 my-auto d-none d-sm-block">
							<div class="text-body-2 font-weight-bold">{{ listBank.bank_account_number }}</div>
						</v-col> -->
						<v-col cols="6" class="py-0 d-block d-sm-none"></v-col>
						<v-col cols="2" class="py-0 d-block d-sm-none"></v-col>
						<v-col cols="10" sm="8" md="8" class="pb-0 pb-md-3 pt-0 mt-n1 my-sm-auto">
							<div class="text-body-2 font-weight-bold">{{ listBank.bank_account_number }}</div>
							<div class="text-body-2 font-weight-bold">{{ listBank.bank_account_name }}</div>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions class="py-3">
					<v-spacer></v-spacer>
					<v-btn color="#1951EF" @click="selectBank" depressed class="text-capitalize font-weight-bold rounded-lg white--text" height="45" width="150">Proses</v-btn>
					<!-- <v-btn v-else @click="modalHide" color="primary" depressed class="text-capitalize font-weight-bold rounded-lg" height="45" width="150">Tutup</v-btn> -->
					<v-spacer></v-spacer>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState } from 'vuex'

export default {
	data () {
		return {
			selectedBank: {},
			dialog: false
		}
	},
	props: {
	},
	computed: {
		...mapState('options', ['bankAccountList']),
	},
	methods: {
		modalShow(bank) {
			this.dialog = true
			this.selectedBank = bank
		},
		modalHide() {
			this.dialog = false
		},
		selectBank() {
			this.$emit('action', this.selectedBank)
			this.modalHide()
		}
	}
};
</script>